import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NKDatetime } from './ng2-datetime';

@NgModule({
    imports: [CommonModule, FormsModule, ReactiveFormsModule],
    exports: [NKDatetime],
    declarations: [NKDatetime]
})
export class NKDatetimeModule {
}



// WEBPACK FOOTER //
// C:/Users/oggy.yuristantyo/source/Workspaces/UI_SBN_Ritel_Web/~/ng2-datetime/src/ng2-datetime/ng2-datetime.module.ts